import { getFaqPath } from "../../../utils/links";
import { useNavigate } from "react-router-dom";
import styles from "./Faq.module.scss";
import helpIcon from "./icons/help.png";

export const Faq = () => {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate(getFaqPath('q=q1'));
    };

    return (
        <div className={styles.question}>
            <button type="button" className={styles.helpButton} onClick={handleClick}>
                <span className={styles.text}>Что тут нужно делать и зачем?</span>
                <img src={helpIcon} alt="FAQ" />
            </button>
        </div>
    );
};
